import React, { Dispatch, SetStateAction, useMemo } from 'react'
import {
  useHasReceptor,
  useReceptor,
} from 'src/pages/Receptors/receptors.hooks'
import { TextInput } from 'src/components/Reusable/Inputs'
import { DerivedTextArea } from '../../../Modal/Type/styles'
import { DocumentFormData, DocumentType } from './AddDocumentForm'

type DocumentLinkProps = {
  formData: DocumentFormData
  setFormData: Dispatch<SetStateAction<DocumentFormData>>
  isValidLink: boolean
  formId: string
  type: DocumentType
}

const placeholder = `Please enter a valid url that begins with "https://" or "http://"`
const errMsg = `Please ensure your url begins with "https://" or "http://"`

export function DocumentLink({
  formData,
  setFormData,
  isValidLink,
  formId,
  type,
}: DocumentLinkProps): JSX.Element {
  const { data: HasReceptor } = useHasReceptor('trr-sharepoint', true)
  const hasSharepointReceptor = useMemo(
    () => HasReceptor?.getHasReceptor() || false,
    [HasReceptor],
  )
  const { data: receptor } = useReceptor({
    modelId: 'trr-sharepoint',
    shouldFetch: hasSharepointReceptor,
  })

  const spCredentials = useMemo(() => {
    return JSON.parse(receptor?.getCredentials() || '{}')
  }, [receptor])
  return (
    <>
      {type === DocumentType.LINK && (
        <DerivedTextArea
          required
          name="body"
          initVal={formData.body as string}
          placeholder={
            type === DocumentType.LINK
              ? placeholder
              : 'Please enter a valid SharePoint link'
          }
          form={formId}
          setFormData={
            setFormData as Dispatch<SetStateAction<{ [key: string]: string }>>
          }
          isValid={isValidLink}
          errorMessage={
            type === DocumentType.LINK
              ? errMsg
              : type === DocumentType.SHAREPOINTLINK
              ? `Please ensure your url begins with ${
                  spCredentials?.baseurl || 'https://'
                }`
              : undefined
          }
        />
      )}
      {type === DocumentType.SHAREPOINTLINK && (
        <TextInput
          required
          name="body"
          initVal={formData.body as string}
          placeholder="Please enter a valid SharePoint link"
          form={formId}
          onChangeCb={(e) => setFormData((prev) => ({ ...prev, body: e }))}
          isValid={isValidLink}
          errorMessage={
            'Please enter a valid SharePoint url that begins with ' +
            (spCredentials?.baseurl || 'https://')
          }
        />
      )}
    </>
  )
}
